/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Support',
    lead: 'Alle supporttickets op het platform, filterbaar op status en prioriteit.',
    filterStatus: 'Status',
    filterPriority: 'Prioriteit',
    allStatuses: 'Alle statussen',
    allPriorities: 'Alle prioriteiten',
    empty: 'Geen tickets voldoen aan deze filters.',
    rowsLabel: 'de tickets',
    subject: 'Onderwerp',
    company: 'Bedrijf',
    status: 'Status',
    priority: 'Prioriteit',
    createdAt: 'Geopend',
  },
  status: {
    open: 'Open',
    in_progress: 'In behandeling',
    resolved: 'Opgelost',
    closed: 'Gesloten',
  },
  priority: {
    low: 'Laag',
    normal: 'Normaal',
    high: 'Hoog',
    urgent: 'Urgent',
  },
  detail: {
    thisTicket: 'dit ticket',
    requesterTitle: 'Aanvrager',
    requesterLabel: 'de aanvrager',
    controlsTitle: 'Status & prioriteit',
    save: 'Opslaan',
    threadTitle: 'Gesprek',
    threadEmpty: 'Nog geen berichten.',
    replyLabel: 'Antwoord',
    reply: 'Antwoord versturen',
  },
} as const;
